//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import countries from '@/static/countries.json'; // Assuming countries.json is in the static folder
import PhoneNumber from '@/components/PhoneNumber.vue';

export default {
  name: 'ContactForm',

  components: {
    PhoneNumber,
  },

  data() {
    return {
      name: '',
      email: '',
      phone: '',
      countryOfResidence: null,
      phoneCode: null,
      phoneNumber: null,
      countries: countries,
      emailValidated: false,
      phoneValidated: false,

    };
  },
  computed: {
    phoneValidatedComputed() {
      return this.phoneValidated;
    },
    submitButtonDisabled() {
      return this.phoneValidated === false || this.name === '' || this.countryOfResidence === null;
    },
  },
  methods: {

    validatePhoneNumber(phoneNumber) {
      const phoneRegex = /^(\+\d{1,2})?\d{8,}$/;
      console.log(phoneNumber, phoneRegex.test(phoneNumber));
      return this.phoneValidated = phoneRegex.test(phoneNumber);
    },

    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return this.emailValidated = emailRegex.test(this.email);
    },

    choosePhone(phone) {
      this.phone = phone.formattedNumber;
      this.validatePhoneNumber(phone.formattedNumber);
      this.emitData();

    },

    emitData() {
      this.$emit('user-data-update', {
        name: this.name,
        phone: this.phone,
        email: this.email,
        countryOfResidence: this.countryOfResidence,
      })
    }

  }


}
